export const NUMBER_FORMAT_LOCALE = "en-US";

const quantityFormatter = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const unitPriceFormatter = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const amountFormatter = new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function toNumber(value: number | string | null | undefined): number {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const numericValue = typeof value === "number" ? value : Number(value);

  if (!Number.isFinite(numericValue)) {
    return 0;
  }

  return numericValue;
}

/** Số lượng (`so_luong*`) — 2 decimals, en-US. */
export function formatQuantity(value: number | string): string {
  const numericValue = toNumber(value);

  if (numericValue === 0) {
    return "0.00";
  }

  return quantityFormatter.format(numericValue);
}

/** Đơn giá (`don_gia*`, `so_tien`) — 0 decimals, en-US. */
export function formatUnitPrice(value: number | string): string {
  const numericValue = toNumber(value);

  if (numericValue === 0) {
    return "0";
  }

  return unitPriceFormatter.format(numericValue);
}

/** Thành tiền / tổng tiền — rounded integer, en-US. */
export function formatAmount(value: number | string): string {
  const numericValue = toNumber(value);

  if (numericValue === 0) {
    return "0";
  }

  return amountFormatter.format(Math.round(numericValue));
}

export function calcLineAmount(
  donGia: number | string,
  soLuong: number | string
): number {
  return Math.round(toNumber(donGia) * toNumber(soLuong));
}

export function parseFormattedNumber(
  value: string,
  locale = NUMBER_FORMAT_LOCALE
): number {
  const thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, "");
  const decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, "");

  const normalized = value
    .trim()
    .replace(new RegExp("\\" + thousandSeparator, "g"), "")
    .replace(new RegExp("\\" + decimalSeparator), ".");

  const parsed = parseFloat(normalized);

  return Number.isFinite(parsed) ? parsed : 0;
}
